module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hoverable clickable pa-2 rounded",
    staticStyle: {
      "display": "flex",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.openDocument
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin": "2px 20px 0px 6px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.documentStyling.path,
      "width": "50",
      "height": "50",
      "alt": "Document",
      "title": "Document"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.document.name)), _c('br'), _vm._v(" "), (_vm.documentStyling.status) ? _c('span', {
    staticClass: "subtle",
    style: ({
      color: _vm.documentStyling.textColour
    })
  }, [_vm._v(_vm._s(_vm.documentStyling.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.document.date) ? _c('span', {
    style: ({
      color: _vm.freshness.textColour
    })
  }, [_vm._v(_vm._s(_vm.freshness.text))]) : _vm._e(), _vm._v(" "), (_vm.document.messageToClient) ? _c('div', {
    staticStyle: {
      "background-color": "rgba(255, 230, 0, 0.6)",
      "padding-left": "5px",
      "padding-right": "5px",
      "border-radius": "7px"
    }
  }, [_vm._v(_vm._s(_vm.document.messageToClient))]) : _vm._e(), _vm._v(" "), (!_vm.document.received) ? [_c('ul', {
    staticStyle: {
      "color": "grey"
    }
  }, _vm._l((_vm.document.checks), function(check, index) {
    return _c('li', {
      key: index,
      style: (_vm.checkStyle(check))
    }, [_vm._v(_vm._s(check.check))])
  }), 0), _vm._v(" "), _vm._l((_vm.document.links), function(link, index2) {
    return _c('a', {
      key: index2,
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": link.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "hoverable clickable rounded-corners",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "opacity": "0.4",
        "margin": "2px 6px 0px 6px",
        "vertical-align": "middle"
      },
      attrs: {
        "src": "https://taco.insightprocessing.com.au/static/images/cloud-download.png",
        "width": "30",
        "height": "30",
        "title": "Download",
        "alt": "Download"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#666",
        "padding": "7px 4px"
      }
    }, [_vm._v(_vm._s(link.display))])])])
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0d7391"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/ChecklistDocument.vue
// module id = 2616
// module chunks = 1